// extracted by css-extract-rspack-plugin
export default {"PickerGrid":"DateOffsetIntervalPicker-module__PickerGrid___M1euY","selectWrapper":"DateOffsetIntervalPicker-module__selectWrapper___C1HKv"};